import React from 'react';

function Turkey(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_123976)">
        <mask
          id="mask0_800_123976"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_123976)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#E31D1C"
          />
          <mask
            id="mask1_800_123976"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_123976)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.0288 16.1135C15.6198 15.586 13.733 13.7937 13.7549 11.1663C13.7754 8.70692 15.4506 6.62807 18.0988 6.0653C20.747 5.50254 23.0784 6.69715 23.0784 6.69715C22.3466 5.16134 19.8038 4.08239 17.7192 4.08549C13.8389 4.09127 9.70236 6.88851 9.66671 11.1663C9.62974 15.6013 14.0963 18.1271 18.0246 18.1212C21.1737 18.1165 22.6675 16.2014 22.9769 15.3867C22.9769 15.3867 20.4377 16.641 18.0288 16.1135ZM23.5163 10.3266L21.1162 11.1102L23.8243 11.9594L23.7781 14.4968L25.5625 12.5932L28.5101 12.7836L26.1743 10.9988L27.7078 9.09503L25.2109 9.84201L23.4262 8.07842L23.5163 10.3266Z"
              fill="#F7FCFF"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_123976">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Turkey;
